import { Component, OnInit } from '@angular/core';
import {ModalComponent} from "../../../../shared/components/modal/modal.component";
import {NgxSmartModalService} from "ngx-smart-modal";
import {JobService} from "../../../../core/services/job/job.service";
import {Job} from "../../../../shared/types/models/job.model";
import {ActivatedRoute, Router} from "@angular/router";
import {User} from "../../../../shared/types/models/user.model";
import {AuthService} from "../../../../core/services/auth/auth.service";
import {UserService} from "../../../../core/services/user/user.service";
import {first} from "rxjs/operators";
import {NgxSpinnerService} from "ngx-spinner";
import {ToastrService} from "ngx-toastr";
import {DataEntityService} from "../../../../core/services/data-entity/data-entity.service";

@Component({
  selector: 'app-price-summary-modal',
  templateUrl: './price-summary-modal.component.html',
  styleUrls: ['./price-summary-modal.component.scss']
})
export class PriceSummaryModalComponent extends ModalComponent implements OnInit {

  job: Job;
  price: any;
  bookingUrl: string;

  user: User;
  showLogin = false;

  constructor(public ngxSmartModalService: NgxSmartModalService,
              public jobService: JobService,
              public router: Router,
              public route: ActivatedRoute,
              public authService: AuthService,
              public userService: UserService,
              public ngxSpinnerService: NgxSpinnerService,
              public toastr: ToastrService, public dataEntityService: DataEntityService) {
    super(ngxSmartModalService, 'priceSummaryModal', 'Price Summary', 'create')
  }

  ngOnInit() {
    this.bindData();
    this.jobService.calculate$(this.job.id)
      .subscribe(price => {
        this.price = price;
        this.bookingUrl = `https://calcufr8.tk/booking/${this.job.id}`;
      });

    const accountId = 'f2aba69b-355e-4f9a-bab4-a0db6a44e8fc';
    this.user = new User();
    this.user.accountId = accountId;
  }

  bindData() {
    const modalData = this.ngxSmartModalService.getModal('priceSummaryModal').getData();
    this.job = modalData.job;
  }

  create(): void {

    if (this.noUser() && !this.showLogin) {
      this.userService.create$(this.user)
        .subscribe(user => {
          this.login(`/booking/${this.job.id}`);
        });
    } else if (this.showLogin) {
      this.login(`/booking/${this.job.id}`);
    } else {
      this.router.navigate([`/booking/${this.job.id}`]);
    }
  }

  login(url): void {
    this.ngxSpinnerService.show();
    this.authService.login(this.user.username, this.user.password)
      .pipe(first())
      .subscribe(data => {

        const id = data.user.id;
        this.job.createdById = id;

        this.jobService.update$(this.job)
          .subscribe(job => {
            this.toastr.success('Logged in successfully', 'Login Success');
            this.router.navigate([url]);
            this.ngxSpinnerService.hide();
          });
      }, error => {
        this.toastr.error('Username or password are incorrect, please try again.', 'Login Failure');
      })
  }

  deleteJob(): void {
    this.jobService.delete$(this.job.id)
      .subscribe(_ => {
        this.router.navigate(['/']);
        this.close();
      });
  }

  noUser(): boolean {
    return !this.authService.isAuthenticated();
  }

  bookDisabled(): boolean {
    if (this.noUser()) {
      if (this.showLogin) {
        return this.user.username == '' || this.user.password == '';
      } else {
        return this.user.username == '' || this.user.email == '' || this.user.password == '';
      }
    }
  }

  toggleLogin(): void {
    this.showLogin = !this.showLogin;
  }

}
